import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { NotificationBell } from '../../../NotificationSystem';

const Topbar = ({ className = '' }) => {
    return (
        <Box
            className={`Topbar ${className}`}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={1}
        >
            <NotificationBell />
        </Box>
    );
};

Topbar.propTypes = {
    className: PropTypes.string,
};

export default Topbar;
